import React from 'react';
import PropTypes from 'prop-types';

import { TableHead as MuiTableHead } from '@material-ui/core';

const TableHead = ({ children, ...rest }) => {
  return (
    <MuiTableHead
      {...rest}
    >
      { children }
    </MuiTableHead>
  )
}

TableHead.defaultProps = {
  children: null,
};

TableHead.propTypes = {
  children: PropTypes.node,
};

export default TableHead;



// WEBPACK FOOTER //
// ./src/components/base/TableHead/TableHead.js